export default __webpack_public_path__ + "static/hub-student-writing-d8b373243f28c23a5011a90b3684ff6b.jpg";